import { gridGutter } from "@maxmilhas/hangar-components-atomic/public/styles/components/quarks/layout";
import { Card } from "@maxmilhas/hangar-components-atomic/public";
import { blue, grayBorder, white, grayFont, green, grayShadow } from "@maxmilhas/hangar-components-atomic/public/styles/components/quarks/colors";

export const containerMyAccountMenu = `
	@media screen and (max-width: 425px) {
		display: none;
	}
`;

export const myAccountMenu = `
  @media screen and (max-width: 768px) {
	.list-unstyled {
		display: flex;
		flex-direction: column;
		justify-content: flex-start;
		margin-bottom: 0;
	
		li {
			&:last-of-type {
				margin-bottom: 0;
			}
		}
  }
}
`
export const listUnstyled = `
	padding-left: 0;
	list-style: none;
`

export const menuList = `
	margin-bottom: $grid-gutter-width;
`
export const pageTitle = `
	font-size: 20px;
    font-weight: bold;
    text-transform: capitalize;
`
export const helloUser = `
  color: ${blue};
`

export const navItem = `
	height: 56px;
	margin-left: -${gridGutter}px;
	margin-right: -${gridGutter}px;
	line-height: 56px;
	padding-left: 24px;

	i { 
		color: ${green}; 
		font-size: 16px;
		margin-right: 10px;
	}
`

export const navLink = `
	color: ${grayFont};
	
	&:hover { 
		font-weight: bold;
		color: ${grayFont};
	}
`

export const selectedNavLink = `
	color: ${green};
	font-weight: bold;

	&:hover { 
		color: ${green};
		font-weight: bold;
	}

	.navItem:active {
		background-color: ${grayShadow};
		border-left: 5px solid ${green};
	}
`
export const selectedNavItem = `
	height: 56px;
	margin-left: -${gridGutter}px;
	margin-right: -${gridGutter}px;
	line-height: 56px;
	padding-left: 24px;

	background-color: ${grayShadow};
	border-left: 5px solid ${green};
	
	i { 
		color: ${green}; 
		font-size: 16px;
		margin-right: 10px;
	}
`